export const goToTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0
}